module.exports = __webpack_public_path__ + "static/img/aiznhh.292f38c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aiznhh.png
// module id = lion
// module chunks = 0